<a class="d-block text-decoration-none" [class]="empData?.classes" [ngClass]="{'active' : empData?.Active, 'not-active' : !empData?.Active}" [attr.id]="empData?.elId">
    <span class="d-block" *ngIf="empData?.name" [innerHTML]="empData.name | replaceSlash"></span>
    <span class="d-block" *ngIf="empData?.description">{{empData.description}}</span>
    <div class="flag-wrapper" *ngIf="empData?.flags?.length>0">
        <img class="flag" [attr.src]="'../../../assets/icons/flags/'+flag+'.svg'" *ngFor="let flag of empData.flags" alt="Country Flag Image">
    </div>
</a>